module.exports = __webpack_public_path__ + "static/media/redaction_de_contenus_LTM.72676b34.doc";